const { REACT_APP_USER_FILES } = process.env;
const createImageURL = (source) => source  ? source.startsWith("http") ? source : `${REACT_APP_USER_FILES}${source}` : "";
export default createImageURL;